var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 403",
    transform: "translate(269 48)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h140v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 402",
    fill: "none",
    d: "M0 0h140v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 180.5 228.5)",
    clipPath: "url(#arrowIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(269 48)",
    clipPath: "url(#arrowIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 316",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 336",
    d: "M139.594 34.911L111.048.616a1.7 1.7 0 00-3.011 1.09v68.588a1.7 1.7 0 003.011 1.089l28.546-34.294a1.7 1.7 0 000-2.178"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 337",
    d: "M1.246 21A1.129 1.129 0 000 21.948v28.1A1.129 1.129 0 001.246 51H7.46V21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 400",
    d: "M26.867 21h82.37v30h-82.37z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 401",
    d: "M12.227 21h9.872v30h-9.872z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.4a0ef8b6c8ad5c3a.svg";
export { ForwardRef as ReactComponent };